export const cards = [
  { type: 'visa', patterns: [4], length: [13, 16, 19], cvcLength: [3], luhn: true },
  { type: 'mastercard', patterns: [51, 52, 53, 54, 55, 22, 23, 24, 25, 26, 27], length: [16], cvcLength: [3], luhn: true },
  { type: 'amex', patterns: [34, 37], length: [15], cvcLength: [4], luhn: true },
  { type: 'discover', patterns: [60, 64, 65, 622], length: [16, 19], cvcLength: [3], luhn: true },
];

export function detectCardType(cardNumber) {
  const sanitized = cardNumber.replace(/\D/g, '');
  // eslint-disable-next-line no-restricted-syntax
  for (const card of cards) {
    if (
      card.patterns.some((p) => sanitized.startsWith(p.toString()))
        && card.length.includes(sanitized.length)
    ) {
      return card.type;
    }
  }
  return 'unknown';
}

function luhnCheck(cardNumber) {
  const digits = cardNumber.replace(/\D/g, ''); // Remove non-numeric characters
  let sum = 0;
  let shouldDouble = false;

  // Iterate over the digits from right to left
  // eslint-disable-next-line no-plusplus
  for (let i = digits.length - 1; i >= 0; i--) {
    let digit = parseInt(digits[i], 10);

    if (shouldDouble) {
      digit *= 2;
      if (digit > 9) {
        digit -= 9; // Subtract 9 if the doubled digit is greater than 9
      }
    }

    sum += digit;
    shouldDouble = !shouldDouble; // Alternate doubling
  }

  return sum % 10 === 0; // Valid if the sum is divisible by 10
}

// Updated validateDebitCard Function
export function isValidCard(cardNumber, cardsAccepted = []) {
  if (!cardNumber) {
    return false;
  }

  const sanitized = cardNumber.replace(/\D/g, '');
  const cardType = detectCardType(sanitized);

  if (cardType === 'unknown') {
    return false;
  }

  if (cardsAccepted.length > 0 && !cardsAccepted.includes(cardType)) {
    return false;
  }

  const card = cards.find((c) => c.type === cardType);
  if (!card) {
    return false;
  }

  const isValidPattern = card.patterns.some((p) => sanitized.startsWith(p.toString()));
  const isValidLength = card.length.includes(sanitized.length);
  const isValidLuhn = card.luhn ? luhnCheck(sanitized) : true;

  return isValidPattern && isValidLength && isValidLuhn;
}
export function isValidCVV(cardNumber = '', cvv = '') {
  const sanitizedCard = cardNumber.replace(/\D/g, '');
  const sanitizedCVV = cvv.replace(/\D/g, '');

  const cardType = detectCardType(sanitizedCard);
  if (cardType === 'unknown') { return false; }

  const card = cards.find((c) => c.type === cardType);
  if (!card) { return false; }

  return card.cvcLength.includes(sanitizedCVV.length);
}
